import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'popup-image',
  templateUrl: './popup-image.component.html',
  styleUrls: ['./popup-image.component.css']
})
export class PopupImageComponent implements OnInit {

  constructor(private translate: TranslateService){}

  ngOnInit(): void {
  }

}
